import React, { useEffect } from 'react'
import './certificationAndAward.css'
import { Divider } from 'antd'
import noData from '../../../assets/img/Emptyjobs.png'

const CertificationAndAward = (data) => {
  return (
    <div className='certificationAndAward-main'>
        
       
      {data?.data?.length > 0 ? data?.data?.map((res, index) => {
        return (
          <>
            <div className="certificationAndAward-container" key={index}>
              {res?.Description}
            </div>
            {data?.data?.length > 0 && data?.data?.length - 1 != index && <Divider />}
          </>
        )
      })
        :
        <>
          <div style={{
            width: '50%',
            margin: 'auto',
          }}>
            <img src={noData} style={{ width: '100%' }} />
          </div>
          <div style={{ textAlign: 'center' }}>No Certifications & Awards!</div>
        </>
      }      
               
                </div>  
  )
}
export default CertificationAndAward;



 